import { Link, Stack } from "@mui/material";
import { CardWrapper, H1Component } from "./component";
import { TextBlock } from "./component";
import { componentMapper, ComponentMapperKeys } from "../../constant";
import { AccountPlan } from "../../../types";

export const ContentBody = ({ accountPlan }: { accountPlan?: AccountPlan }) => {
  if (!accountPlan) return null;

  const topics = accountPlan.topics;

  return (
    <Stack gap="52px">
      {topics.map((topic) => (
        <Stack gap="44px" key={topic.id} id={topic.id}>
          <Stack gap="24px" alignItems="flex-start">
            <Stack gap="16px" alignItems="flex-start">
              <H1Component text={topic.title} />
              {componentMapper.topicDescription(topic.description)}
            </Stack>
            <TextBlock text={topic.text} />
          </Stack>
          {topic.subTopics.map((subTopic) => (
            <Stack gap="32px" key={subTopic.id}>
              <Stack gap="20px">
                <Stack gap="8px" id={subTopic.id}>
                  <Link
                    href={subTopic.playbook_url || undefined}
                    target={"_blank"}
                    sx={{
                      textDecoration: "none",
                      alignSelf: "flex-start",
                      cursor: subTopic.playbook_url ? "pointer" : "auto",
                      color: "#024760",
                      "&:hover": {
                        textDecoration: subTopic.playbook_url
                          ? "underline"
                          : "none",
                      },
                    }}
                  >
                    {componentMapper.h2(subTopic.title)}
                  </Link>
                  {componentMapper.subTopicDescription(subTopic.description)}
                </Stack>
                {componentMapper.text(subTopic.text)}
              </Stack>
              {subTopic.article.map(({ title, content, text, isCard, id }) => (
                <CardWrapper key={id} id={id} isCard={isCard}>
                  <>
                    <Stack id={id} gap="16px">
                      {title && componentMapper.h3(title)}
                      {text && componentMapper.text(text)}
                    </Stack>
                    {content &&
                      Array.isArray(content) &&
                      content.map(({ type, value }) =>
                        componentMapper[type as ComponentMapperKeys](
                          value as never,
                        ),
                      )}
                  </>
                </CardWrapper>
              ))}
            </Stack>
          ))}
        </Stack>
      ))}
    </Stack>
  );
};
